<template>
  <div>
    <modal
      :show.sync="modalShow"
      :backdrop="modalBackdrop"
      effect="zoom"
      width="400">
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">
          <i class="fas fa-minus-circle" aria-hidden="true"></i> Remove Entry Point
        </h4>
      </div>
      <div slot="modal-body" class="modal-body">
        Are you sure you want to remove the entry point {{ selectedKey }} from the App Config?
        <p class="text-danger">This action cannot be undone.</p>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-secondary" v-on:click="modalCloseCallback">Close</button>
        <button type="button" class="btn btn-danger" v-on:click="modalRemoveCallback">Remove</button>
      </div>
    </modal>
    <div v-if="showConfigData">
      <vue-good-table
          title="Configured entry points"
          :columns="columns"
          :rows="config.entryPointList"
          :sort-options="{
            enabled: true,
            initialSortBy: {field: 'key', type: 'asc'}
          }"
          :search-options="{ enabled: true }"
          :paginationOptions="{ enabled: true }"
          :rowStyleClass="tableRowClass"
          styleClass="vgt-table striped bordered table-hover"
          :lineNumbers="true">
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'key'">{{ props.row.key }}</span>
          <span v-if="props.column.field == 'value'">{{ props.row.value }}</span>
          <span v-if="props.column.label == 'Actions'">
            <button type="button" class="btn btn-sm btn-info"
              v-on:click="btnUpdateEntryPoint(props.row.key, props.row.value)">
                <i class="fas fa-edit" aria-hidden="true"></i> Update
            </button>
            <button type="button" class="btn btn-sm btn-danger"
              v-on:click="btnRemoveEntryPoint(props.row.key, props.row.value)">
                <i class="fas fa-minus-circle"></i> Remove
            </button>
          </span>
        </template>
      </vue-good-table>
    </div>
    <div v-else
      id="timeouts-info"
      class="alert alert-success"
      role="alert">
      <i class="fa fa-info-circle" aria-hidden="true"></i>
      <strong>No Entry Points.</strong><br>
      There are no entry point timeouts set for this app
    </div>
  </div>
</template>

<script>
  import { modal } from 'vue-strap'
  export default {
    props: ['config'],
    components: {
      modal
    },
    data () {
      return {
        modalShow: false,
        modalBackdrop: false,
        selectedKey: null,
        selectedValue: null,
        columns: [
          {
            label: 'Entry Point',
            field: 'key',
            filterable: true
          },
          {
            label: 'Value',
            field: 'value'
          },
          {
            label: 'Actions',
            field: 'btn',
            html: true
          }
        ]
      }
    },
    methods: {
      tableRowClass: function (row) {
        if (row.value >= 45) {
          return 'table-danger'
        } else if (row.value >= 20) {
          return 'table-warning'
        }
        return 'table-primary'
      },
      btnUpdateEntryPoint: function (key, value) {
        this.$parent.updateEntryPoint(key, value, true)
      },
      btnRemoveEntryPoint: function (key, value) {
        this.modalShow = true
        this.selectedKey = key
        this.selectedValue = value
      },
      modalRemoveCallback: function () {
        this.$parent.updateEntryPoint(this.selectedKey, this.selectedValue, false)
        this.$parent.deleteEntryPoint(this.selectedKey, this.selectedValue)
        this.modalCloseCallback()
      },
      modalCloseCallback: function () {
        let vm = this
        vm.modalShow = false
      }
    },
    computed: {
      configData: function () {
        return this.config.processEntryPointTimeouts
      },
      showConfigData: function () {
        return Object.keys(this.config.processEntryPointTimeouts).length > 0
      }
    },
    created () {
      let vm = this
      window.addEventListener('keydown', function (e) {
        if (e.keyCode === 27) {
          vm.modalCloseCallback()
        }
      })
    }
  }
</script>

<style scoped>  
</style>



// WEBPACK FOOTER //
// AppConfigEntryPoint.vue?5e70aa3f